import { useMemo } from 'react'
import useOfferMetaDataList from 'hooks/Offers/useOfferMetaDataList'
import { unique } from 'lib/array/arrayUtils'
import useOffers from 'hooks/Offers/useOffers'
import { excludeNullOrUndefined } from 'checkout/utils'

export default function useSearchMapResults(
  filters: App.OfferListFilters,
  selectedOfferIds: Array<string>,
  overrideOfferList?: App.OfferList,
  includeAllBedbankWithSales?: boolean,
  pageSize: number = 20,
  offerList?: App.OfferList,
) {
  const offerMetaData = useOfferMetaDataList({ ...filters, includeAllBedbankWithSales })

  const offerIds = useMemo(() => overrideOfferList ? unique([...overrideOfferList.offerIds, ...selectedOfferIds]) : [], [overrideOfferList, selectedOfferIds])

  const [loadedOffers, offersFetching] = useOffers<App.Offer | App.BedbankOffer>(offerIds)

  const offers = useMemo(() => {
    const loadedOfferMap = new Map(loadedOffers.map(offer => [offer.id, offer]))
    const offerMetaMap = new Map(offerMetaData.map(meta => [meta.offerId, meta]))
    return offerIds.map(id => loadedOfferMap.get(id) || offerMetaMap.get(id)).filter(excludeNullOrUndefined)
  }, [loadedOffers, offerMetaData, offerIds])

  const totalNumOffers = overrideOfferList?.offerCount || 0

  const fetchingList = (offerList?.offerIds?.length || 0) < totalNumOffers
  const fetchingPage = (overrideOfferList?.offerIds?.length || 0 % pageSize) < pageSize && fetchingList
  const error = overrideOfferList?.error
  const allOffersLoaded = !fetchingList && !offersFetching && offers.length === totalNumOffers
  const noOffersAvailable = !fetchingList && totalNumOffers === 0
  const key = overrideOfferList?.key

  return useMemo(() => ({
    offers,
    totalNumOffers,
    fetchingList,
    error,
    allOffersLoaded,
    noOffersAvailable,
    key,
    fetchingPage,
  }), [offers, totalNumOffers, fetchingList, error, allOffersLoaded, noOffersAvailable, key, fetchingPage])
}
